// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_o0-0";